import { Component, ViewChild } from '@angular/core';

import {  App,  List, NavController } from 'ionic-angular';

import {InAppBrowser} from 'ionic-native';

import { JobInfo } from '../job-info/job-info';

import { UserData } from '../../providers/user-data';

import { Http } from '@angular/http';

import 'rxjs/add/operator/map';



@Component({
  templateUrl: 'build/pages/jobs/jobs.html'
})


export class Jobs {

 

        jobs: Array<any>;

 username: string;


  constructor(
    public app: App,
    public navCtrl: NavController,
    public user: UserData,
    private http: Http
  ) {

  }

  ionViewDidEnter() {
    this.app.setTitle('Job Info');
  }


   ngAfterViewInit() {
    this.loadjobs();
  }




  loadjobs() {



  this.user.getUsername().then((username) => {
    this.username = username;
 var url = 'http://letpco.co.uk/api/v1/jobs?authkey='+this.username;

          this.http.get(url).subscribe(res => {

 this.jobs = res.json().data;
        
      
     
      });

 return 'hi';

  });
    }



   
    itemTapped(event, movie) {
        this.navCtrl.push(JobInfo, movie.jobid);
    }





 
}
